export default __webpack_public_path__ + "static/ogcard-52d9bbb5c016914768efa65ee6b3af5d.jpg";